import { render, staticRenderFns } from "./deanHeader.vue?vue&type=template&id=6a8addbe&scoped=true"
import script from "./deanHeader.vue?vue&type=script&lang=ts"
export * from "./deanHeader.vue?vue&type=script&lang=ts"
import style0 from "./deanHeader.vue?vue&type=style&index=0&id=6a8addbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8addbe",
  null
  
)

export default component.exports